var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1278,
    cy: 26,
    r: 21.1278,
    fill: "#DFEAEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_3160)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_220_3160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4376 15.3523C27.8682 15.3523 30.7616 17.7223 31.6029 20.9287H30.9633C30.298 20.9287 29.9286 21.7078 30.3451 22.2327L31.858 24.1392C32.1753 24.5391 32.7771 24.5391 33.0944 24.1392L34.6073 22.2327C35.0239 21.7078 34.6545 20.9287 33.9891 20.9287H33.2097C32.3355 16.8425 28.7347 13.7715 24.4376 13.7715C24.0061 13.7715 23.6562 14.1253 23.6562 14.5619C23.6562 14.9984 24.0061 15.3523 24.4376 15.3523Z",
    fill: "url(#paint0_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6086 22.2327C35.0251 21.7078 34.6557 20.9287 33.9903 20.9287H33.2109C33.2109 20.9287 33.438 22.2316 33.5116 23.615L34.6086 22.2327Z",
    fill: "url(#paint1_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6038 20.9287H30.9642C30.2988 20.9287 29.9295 21.7078 30.346 22.2327L31.8111 24.079C31.7819 22.1819 31.6038 20.9287 31.6038 20.9287Z",
    fill: "url(#paint2_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 35.7727C23.7534 35.7727 29.0255 30.4394 29.0255 23.8605C29.0255 17.2815 23.7534 11.9482 17.25 11.9482C10.7466 11.9482 5.47461 17.2815 5.47461 23.8605C5.47461 30.4394 10.7466 35.7727 17.25 35.7727Z",
    fill: "url(#paint3_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2477 34.1188C22.8481 34.1188 27.3881 29.526 27.3881 23.8607C27.3881 18.1953 22.8481 13.6025 17.2477 13.6025C11.6474 13.6025 7.10742 18.1953 7.10742 23.8607C7.10742 29.526 11.6474 34.1188 17.2477 34.1188Z",
    fill: "url(#paint4_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47461 23.8609C5.47461 30.4399 10.7467 35.7732 17.25 35.7732C23.7534 35.7732 29.0255 30.4399 29.0255 23.8609C29.0255 22.4361 28.7773 21.0702 28.3238 19.8037H6.17624C5.72276 21.0702 5.47461 22.4361 5.47461 23.8609Z",
    fill: "url(#paint5_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92376 32.2838C13.5223 36.9357 20.9781 36.9358 25.5768 32.2838C30.1754 27.6317 30.1753 20.0894 25.5768 15.4373C24.5808 14.4298 23.4505 13.6414 22.2447 13.0703L6.58398 28.9129C7.14846 30.1329 7.92781 31.2763 8.92376 32.2838Z",
    fill: "url(#paint6_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 32.9342C22.204 32.9342 26.2199 28.8716 26.2199 23.8602C26.2199 18.8487 22.204 14.7861 17.2501 14.7861C12.2962 14.7861 8.28027 18.8487 8.28027 23.8602C8.28027 28.8716 12.2962 32.9342 17.2501 32.9342Z",
    fill: "url(#paint7_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2199 23.8602C26.2199 18.8488 22.204 14.7861 17.2501 14.7861C12.2963 14.7861 8.28027 18.8487 8.28027 23.8602C8.28027 24.9455 8.4693 25.9861 8.81475 26.9508H25.6855C26.0309 25.9861 26.2199 24.9455 26.2199 23.8602Z",
    fill: "url(#paint8_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5927 17.4439C20.0898 13.9002 14.4104 13.9002 10.9075 17.4439C7.40454 20.9875 7.40454 26.7328 10.9075 30.2764C11.6661 31.0439 12.5271 31.6445 13.4457 32.0795L25.3751 20.0116C24.945 19.0823 24.3514 18.2113 23.5927 17.4439Z",
    fill: "url(#paint9_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3691 15.1885L16.6963 23.7445L23.3691 30.4947C23.4447 30.4233 23.5197 30.3508 23.5935 30.2762C25.275 28.5752 26.1488 26.3668 26.216 24.1381L17.3691 15.1885Z",
    fill: "url(#paint10_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4551 24.6636L19.122 27.3615C19.5591 27.8038 20.2735 27.8222 20.7139 27.3833C20.7197 27.3775 20.7255 27.3717 20.7311 27.3659C21.165 26.9203 21.1468 26.1977 20.7096 25.7555L18.0427 23.0576L16.4551 24.6636Z",
    fill: "url(#paint11_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2517 15.8916C17.0776 15.8916 16.9365 16.0344 16.9365 16.2105V17.44C16.9365 17.6161 17.0776 17.7589 17.2517 17.7589C17.4258 17.7589 17.5669 17.6161 17.5669 17.44V16.2105C17.5669 16.0344 17.4258 15.8916 17.2517 15.8916Z",
    fill: "url(#paint12_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2517 29.9619C17.0776 29.9619 16.9365 30.1047 16.9365 30.2808V31.5103C16.9365 31.6864 17.0776 31.8292 17.2517 31.8292C17.4258 31.8292 17.5669 31.6864 17.5669 31.5103V30.2808C17.5669 30.1047 17.4258 29.9619 17.2517 29.9619Z",
    fill: "url(#paint13_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8128 23.541H23.5974C23.4233 23.541 23.2822 23.6838 23.2822 23.8599C23.2822 24.036 23.4233 24.1788 23.5974 24.1788H24.8128C24.9869 24.1788 25.1281 24.036 25.1281 23.8599C25.1281 23.6838 24.987 23.541 24.8128 23.541Z",
    fill: "url(#paint14_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2189 23.8599C11.2189 23.6838 11.0778 23.541 10.9037 23.541H9.68826C9.51417 23.541 9.37305 23.6838 9.37305 23.8599C9.37305 24.036 9.51417 24.1788 9.68826 24.1788H10.9037C11.0777 24.1788 11.2189 24.036 11.2189 23.8599Z",
    fill: "url(#paint15_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7416 17.0755C13.6545 16.923 13.4618 16.8708 13.311 16.9588C13.1602 17.0469 13.1086 17.2418 13.1956 17.3944L13.8033 18.4592C13.8903 18.6117 14.0831 18.6639 14.2339 18.5759C14.3847 18.4878 14.4363 18.2928 14.3493 18.1403L13.7416 17.0755Z",
    fill: "url(#paint16_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6957 29.2611C20.6086 29.1085 20.4159 29.0563 20.2651 29.1443C20.1143 29.2324 20.0627 29.4274 20.1497 29.5799L20.7574 30.6447C20.8444 30.7972 21.0372 30.8495 21.188 30.7614C21.3388 30.6733 21.3904 30.4784 21.3034 30.3258L20.6957 29.2611Z",
    fill: "url(#paint17_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9045 20.9266L23.9571 20.3119C24.1078 20.2238 24.1595 20.0288 24.0725 19.8763C23.9854 19.7238 23.7926 19.6715 23.6418 19.7596L22.5893 20.3743C22.4385 20.4624 22.3869 20.6574 22.4739 20.8099C22.561 20.9624 22.7538 21.0147 22.9045 20.9266Z",
    fill: "url(#paint18_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5979 26.7947L10.5454 27.4094C10.3946 27.4975 10.343 27.6925 10.43 27.8451C10.517 27.9976 10.7098 28.0498 10.8606 27.9618L11.9131 27.3471C12.0639 27.259 12.1155 27.064 12.0285 26.9115C11.9414 26.7589 11.7486 26.7067 11.5979 26.7947Z",
    fill: "url(#paint19_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.188 16.9588C21.0372 16.8707 20.8444 16.923 20.7574 17.0755L20.1497 18.1403C20.0626 18.2928 20.1143 18.4879 20.2651 18.5759C20.4159 18.664 20.6087 18.6117 20.6957 18.4592L21.3034 17.3944C21.3904 17.2419 21.3388 17.0468 21.188 16.9588Z",
    fill: "url(#paint20_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2339 29.1444C14.0831 29.0563 13.8903 29.1086 13.8033 29.2611L13.1956 30.3259C13.1085 30.4784 13.1602 30.6734 13.311 30.7615C13.4618 30.8496 13.6546 30.7973 13.7416 30.6447L14.3493 29.58C14.4363 29.4275 14.3847 29.2324 14.2339 29.1444Z",
    fill: "url(#paint21_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9131 20.3743L10.8606 19.7596C10.7098 19.6715 10.517 19.7238 10.43 19.8763C10.3429 20.0289 10.3946 20.2239 10.5454 20.3119L11.5979 20.9267C11.7487 21.0148 11.9415 20.9625 12.0285 20.8099C12.1156 20.6574 12.0639 20.4623 11.9131 20.3743Z",
    fill: "url(#paint22_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9571 27.4095L22.9045 26.7947C22.7538 26.7067 22.561 26.7589 22.4739 26.9115C22.3869 27.064 22.4385 27.2591 22.5893 27.3471L23.6419 27.9618C23.7927 28.0499 23.9855 27.9976 24.0725 27.8451C24.1595 27.6925 24.1079 27.4975 23.9571 27.4095Z",
    fill: "url(#paint23_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2508 23.7444H16.6963V18.3318C16.6963 17.3916 16.8091 16.4549 17.0324 15.5423L17.1047 15.2466C17.1425 15.0923 17.3593 15.0923 17.3971 15.2466L17.4694 15.5423C17.6926 16.4549 17.8055 17.3916 17.8055 18.3318V23.7444H17.2508Z",
    fill: "url(#paint24_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.162 23.8608L17.6459 24.1348L15.9592 27.1839C15.5053 28.0043 14.9547 28.766 14.3193 29.4522L14.1135 29.6744C14.0061 29.7904 13.8169 29.6833 13.8584 29.53L13.938 29.2363C14.1838 28.3296 14.5375 27.4564 14.9913 26.636L16.678 23.5869L17.162 23.8608Z",
    fill: "url(#paint25_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2476 24.996C17.8676 24.996 18.3703 24.4875 18.3703 23.8603C18.3703 23.2331 17.8676 22.7246 17.2476 22.7246C16.6276 22.7246 16.125 23.2331 16.125 23.8603C16.125 24.4875 16.6276 24.996 17.2476 24.996Z",
    fill: "url(#paint26_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 23.8604C16.125 24.4876 16.6276 24.9961 17.2476 24.9961C17.8676 24.9961 18.3703 24.4876 18.3703 23.8604C18.3703 23.7245 18.3466 23.5943 18.3034 23.4736H16.192C16.1487 23.5943 16.125 23.7245 16.125 23.8604Z",
    fill: "url(#paint27_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4555 24.6637C16.894 25.1072 17.6048 25.1072 18.0431 24.6637C18.4815 24.2202 18.4815 23.5011 18.0431 23.0577C17.9482 22.9616 17.8404 22.8865 17.7254 22.832L16.2324 24.3424C16.2863 24.4587 16.3606 24.5676 16.4555 24.6637Z",
    fill: "url(#paint28_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2213 23.6396H26.7393V44.0488H29.2213C33.6315 44.0488 37.2073 39.4799 37.2073 33.8442C37.2073 28.2085 33.6315 23.6396 29.2213 23.6396Z",
    fill: "url(#paint29_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2213 23.6396H26.7393V44.0488H29.2213C33.6315 44.0488 37.2073 39.4799 37.2073 33.8442C37.2073 28.2085 33.6315 23.6396 29.2213 23.6396Z",
    fill: "url(#paint30_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2073 33.8443C37.2073 34.6721 37.13 35.4773 36.9844 36.2482C36.7378 37.5535 36.2945 38.7611 35.697 39.8171C35.1515 40.7813 34.4771 41.6186 33.7061 42.2883H26.7393V25.4004H33.7061C34.4771 26.07 35.1515 26.9073 35.697 27.8716C36.2945 28.9275 36.7378 30.1351 36.9844 31.4404C37.13 32.2114 37.2073 33.0166 37.2073 33.8443Z",
    fill: "url(#paint31_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2073 33.8438C37.2073 34.6716 37.13 35.4768 36.9844 36.2477C36.7378 37.553 36.2945 38.7606 35.697 39.8165H26.7393V27.8711H35.697C36.2945 28.927 36.7378 30.1346 36.9844 31.4399C37.13 32.2108 37.2073 33.016 37.2073 33.8438Z",
    fill: "url(#paint32_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2073 33.8443C37.2073 34.672 37.13 35.4772 36.9844 36.2481H26.7393V31.4404H36.9844C37.13 32.2113 37.2073 33.0165 37.2073 33.8443Z",
    fill: "url(#paint33_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7393 44.0488H29.2213C33.6315 44.0488 37.2073 39.4799 37.2073 33.8442C37.2073 33.3452 37.1787 32.8548 37.1246 32.375H26.7393V44.0488Z",
    fill: "url(#paint34_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7378 44.0487C31.1483 44.0487 34.7236 39.4799 34.7236 33.8442C34.7236 28.2084 31.1483 23.6396 26.7378 23.6396C22.3273 23.6396 18.752 28.2084 18.752 33.8442C18.752 39.4799 22.3273 44.0487 26.7378 44.0487Z",
    fill: "url(#paint35_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.739 23.6396C26.2906 23.6396 25.8511 23.6877 25.4229 23.7784V43.9099C25.8511 44.0007 26.2906 44.0487 26.739 44.0487C31.1495 44.0487 34.7249 39.4799 34.7249 33.8442C34.7249 28.2084 31.1495 23.6396 26.739 23.6396Z",
    fill: "url(#paint36_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.752 33.8439C18.752 39.4797 22.3273 44.0485 26.7378 44.0485V44.0485H29.2199C33.6301 44.0485 37.2058 39.4796 37.2058 33.8439C37.2058 33.6356 37.2003 33.4289 37.1907 33.2236H18.7671C18.7574 33.4289 18.752 33.6356 18.752 33.8439Z",
    fill: "url(#paint37_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.737 25.4609C23.114 25.4609 20.1768 29.2144 20.1768 33.8439C20.1768 38.4735 23.114 42.2269 26.737 42.2269C30.36 42.2269 33.2973 38.4735 33.2973 33.8439C33.2973 29.2144 30.36 25.4609 26.737 25.4609Z",
    fill: "url(#paint38_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7393 25.4609V42.227C30.3622 42.227 33.2995 38.4735 33.2995 33.844C33.2995 29.2144 30.3622 25.4609 26.7393 25.4609Z",
    fill: "url(#paint39_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4755 33.844C21.4755 29.4945 24.0683 25.9186 27.3864 25.5018C27.1728 25.475 26.9562 25.4609 26.737 25.4609C23.114 25.4609 20.1768 29.2144 20.1768 33.8439C20.1768 38.4735 23.114 42.2269 26.737 42.2269C26.9562 42.2269 27.1728 42.2129 27.3864 42.1861C24.0683 41.7695 21.4755 38.1935 21.4755 33.844Z",
    fill: "url(#paint40_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7764 38.7914C26.4314 38.7914 26.1076 38.7382 25.8048 38.6321C25.5019 38.5259 25.2355 38.3896 25.0055 38.2233C24.7756 38.0571 24.5953 37.8675 24.4651 37.655C24.3346 37.4425 24.2695 37.2253 24.2695 37.0036C24.2695 36.8835 24.2907 36.7563 24.3329 36.6225C24.3749 36.4886 24.4305 36.3639 24.4995 36.2484C24.5685 36.1328 24.6508 36.0359 24.7468 35.9573C24.8426 35.8786 24.9442 35.8394 25.0516 35.8394C25.174 35.8394 25.2931 35.8832 25.408 35.9708C25.5231 36.0585 25.6455 36.1578 25.776 36.2685C25.9063 36.3793 26.0521 36.4902 26.213 36.6006C26.374 36.7114 26.5618 36.7899 26.7765 36.836V34.5957C26.508 34.4761 26.2379 34.3425 25.9659 34.1948C25.6935 34.0473 25.4483 33.8677 25.2299 33.6556C25.0113 33.4436 24.8312 33.1832 24.6893 32.8744C24.5474 32.5657 24.4767 32.1902 24.4767 31.7475C24.4767 31.3052 24.5399 30.9204 24.6664 30.5931C24.793 30.2659 24.9615 29.9894 25.1724 29.7635C25.3831 29.5377 25.6266 29.3581 25.9025 29.2244C26.1785 29.0907 26.4698 28.9962 26.7765 28.9409V28.553C26.7765 28.4514 26.8167 28.3636 26.8972 28.2897C26.9778 28.2159 27.083 28.1787 27.2135 28.1787C27.3207 28.1787 27.4204 28.2161 27.5124 28.2906C27.6045 28.3651 27.6504 28.4533 27.6504 28.5558V28.9049C27.8266 28.9049 28.0337 28.9235 28.2714 28.9604C28.509 28.9975 28.7332 29.0599 28.9441 29.1476C29.155 29.2355 29.3351 29.3557 29.4845 29.5082C29.6341 29.6608 29.7088 29.8573 29.7088 30.0976C29.7088 30.19 29.6953 30.3009 29.6686 30.4305C29.6416 30.5601 29.5996 30.6849 29.542 30.8049C29.4845 30.9251 29.4098 31.0268 29.3178 31.11C29.2257 31.1933 29.1183 31.2348 28.9958 31.2348C28.9039 31.2348 28.8156 31.2119 28.7312 31.1657C28.6469 31.1196 28.5569 31.0668 28.4611 31.0068C28.3651 30.947 28.2521 30.8893 28.1218 30.834C27.9913 30.7787 27.8344 30.7421 27.6503 30.7235V32.744C27.9109 32.8638 28.1754 32.9976 28.4439 33.145C28.7121 33.2925 28.9556 33.4814 29.174 33.7117C29.3926 33.9422 29.5708 34.2186 29.7088 34.5412C29.8467 34.8637 29.9157 35.2598 29.9157 35.7297C29.9157 36.1628 29.8601 36.55 29.7489 36.8909C29.6377 37.2317 29.4825 37.5289 29.2833 37.7824C29.0838 38.0358 28.8463 38.2432 28.5704 38.4045C28.2942 38.5657 27.9875 38.6786 27.6503 38.743V39.1401C27.6503 39.2404 27.6044 39.3272 27.5124 39.4005C27.4203 39.4732 27.3206 39.5099 27.2134 39.5099C27.0829 39.5099 26.9778 39.473 26.8971 39.3993C26.8167 39.3255 26.7764 39.238 26.7764 39.1368V38.7914ZM26.1555 31.5403C26.1555 31.7433 26.2225 31.9117 26.3567 32.0455C26.4907 32.1795 26.669 32.3018 26.8915 32.4124V30.765C26.6308 30.8298 26.4429 30.9336 26.328 31.0765C26.2129 31.2195 26.1555 31.3741 26.1555 31.5403ZM28.2369 35.9509C28.2369 35.7205 28.1717 35.5292 28.0413 35.3769C27.9109 35.2249 27.7424 35.0889 27.5354 34.9689V36.8223C27.7346 36.7671 27.9013 36.6703 28.0355 36.5319C28.1696 36.3937 28.2369 36.2 28.2369 35.9509Z",
    fill: "url(#paint41_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 39.7235C14.8088 39.7235 11.9154 37.3535 11.0741 34.1472H11.7137C12.379 34.1472 12.7484 33.368 12.3319 32.8431L10.8189 30.9366C10.5016 30.5368 9.89988 30.5368 9.58251 30.9366L8.06961 32.8431C7.65307 33.368 8.02245 34.1472 8.68782 34.1472H9.46723C10.3415 38.2334 13.9423 41.3043 18.2394 41.3043C18.6709 41.3043 19.0208 40.9505 19.0208 40.5139C19.0207 40.0774 18.6709 39.7235 18.2394 39.7235Z",
    fill: "url(#paint42_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06961 32.8432C7.65307 33.3681 8.02245 34.1472 8.68782 34.1472H9.46723C9.46723 34.1472 9.24015 32.8443 9.16652 31.4609L8.06961 32.8432Z",
    fill: "url(#paint43_linear_220_3160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0755 34.1473H11.7151C12.3804 34.1473 12.7498 33.3682 12.3333 32.8433L10.8682 30.9971C10.8974 32.8941 11.0755 34.1473 11.0755 34.1473Z",
    fill: "url(#paint44_linear_220_3160)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_3160",
    x1: 24.9857,
    y1: 13.8827,
    x2: 35.314,
    y2: 24.0925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24CE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_220_3160",
    x1: 34.0303,
    y1: 22.3449,
    x2: 33.9796,
    y2: 20.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_220_3160",
    x1: 30.9779,
    y1: 22.4446,
    x2: 30.9272,
    y2: 20.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_220_3160",
    x1: 10.0471,
    y1: 16.5739,
    x2: 23.1908,
    y2: 29.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_220_3160",
    x1: 24.3449,
    y1: 31.0403,
    x2: 8.89366,
    y2: 15.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_220_3160",
    x1: 17.25,
    y1: 25.6648,
    x2: 17.25,
    y2: 37.0485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#BF1C27",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B12529",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_220_3160",
    x1: 22.1693,
    y1: 27.1488,
    x2: 27.05,
    y2: 30.3365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#BF1C27",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B12529",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A72B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_220_3160",
    x1: 22.7368,
    y1: 29.4106,
    x2: 12.7248,
    y2: 19.5136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_220_3160",
    x1: 16.2239,
    y1: 20.8216,
    x2: 14.0144,
    y2: 14.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_220_3160",
    x1: 12.845,
    y1: 21.7207,
    x2: 8.81978,
    y2: 19.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_220_3160",
    x1: 20.8094,
    y1: 22.8911,
    x2: 16.7201,
    y2: 22.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_220_3160",
    x1: 20.3669,
    y1: 25.9685,
    x2: 16.6683,
    y2: 24.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_220_3160",
    x1: 51.663,
    y1: 40.6932,
    x2: 10.7206,
    y2: 12.9437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_220_3160",
    x1: 45.1762,
    y1: 50.2642,
    x2: 4.23368,
    y2: 22.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_220_3160",
    x1: 50.6426,
    y1: 42.1971,
    x2: 9.70011,
    y2: 14.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_220_3160",
    x1: 46.1943,
    y1: 48.7593,
    x2: 5.25185,
    y2: 21.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_220_3160",
    x1: 50.1145,
    y1: 42.9745,
    x2: 9.172,
    y2: 15.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_220_3160",
    x1: 46.7203,
    y1: 47.9824,
    x2: 5.77786,
    y2: 20.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_220_3160",
    x1: 51.9661,
    y1: 40.2447,
    x2: 11.0236,
    y2: 12.4951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_220_3160",
    x1: 44.8721,
    y1: 50.7133,
    x2: 3.92962,
    y2: 22.9637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_220_3160",
    x1: 52.3381,
    y1: 39.6934,
    x2: 11.3956,
    y2: 11.9438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_220_3160",
    x1: 44.4967,
    y1: 51.2635,
    x2: 3.55416,
    y2: 23.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_220_3160",
    x1: 48.1156,
    y1: 45.9278,
    x2: 7.1731,
    y2: 18.1782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_220_3160",
    x1: 48.7226,
    y1: 45.0302,
    x2: 7.78015,
    y2: 17.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2585,
    stopColor: "#D9D2EC",
    stopOpacity: 0.259
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#D2CAE3",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5751,
    stopColor: "#C6BCD4",
    stopOpacity: 0.575
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    stopColor: "#B6A9BF",
    stopOpacity: 0.707
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#A08FA4",
    stopOpacity: 0.828
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9415,
    stopColor: "#867082",
    stopOpacity: 0.942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_220_3160",
    x1: 16.9257,
    y1: 19.4377,
    x2: 17.8123,
    y2: 19.4377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_220_3160",
    x1: 15.0501,
    y1: 26.5023,
    x2: 15.905,
    y2: 26.9718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_220_3160",
    x1: 16.5609,
    y1: 23.1656,
    x2: 17.814,
    y2: 24.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1027,
    stopColor: "#C0EEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2579,
    stopColor: "#ABEBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4463,
    stopColor: "#89E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6607,
    stopColor: "#5ADEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    stopColor: "#1ED5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01D0FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_220_3160",
    x1: 17.2476,
    y1: 23.8234,
    x2: 17.2476,
    y2: 24.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0290CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    stopColor: "#0290CF",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0290CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_220_3160",
    x1: 17.2188,
    y1: 23.8298,
    x2: 18.0963,
    y2: 24.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0290CF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    stopColor: "#0290CF",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0290CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_220_3160",
    x1: 31.9733,
    y1: 24.4502,
    x2: 31.9733,
    y2: 44.3383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_220_3160",
    x1: 31.9442,
    y1: 35.2998,
    x2: 36.8098,
    y2: 37.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_220_3160",
    x1: 22.4159,
    y1: 32.1969,
    x2: 36.3006,
    y2: 35.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_220_3160",
    x1: 25.4864,
    y1: 31.3689,
    x2: 36.8255,
    y2: 36.1532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_220_3160",
    x1: 27.4431,
    y1: 32.494,
    x2: 36.2789,
    y2: 35.1325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_220_3160",
    x1: 31.9732,
    y1: 34.4114,
    x2: 31.9732,
    y2: 43.4346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_220_3160",
    x1: 20.9669,
    y1: 30.4858,
    x2: 33.5615,
    y2: 37.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_220_3160",
    x1: 29.6334,
    y1: 35.7885,
    x2: 33.8655,
    y2: 39.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_220_3160",
    x1: 27.9789,
    y1: 39.7601,
    x2: 27.9789,
    y2: 44.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_220_3160",
    x1: 18.7088,
    y1: 33.8439,
    x2: 35.7024,
    y2: 33.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_220_3160",
    x1: 27.6524,
    y1: 33.8439,
    x2: 33.5263,
    y2: 33.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_220_3160",
    x1: 6.6722,
    y1: 14.3927,
    x2: 33.3446,
    y2: 40.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_220_3160",
    x1: 13.4806,
    y1: 27.586,
    x2: 31.7862,
    y2: 35.7449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#FE9635",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5597,
    stopColor: "#FE902C",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7719,
    stopColor: "#FE871C",
    stopOpacity: 0.772
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9676,
    stopColor: "#FE7905",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_220_3160",
    x1: 10.4982,
    y1: 37.7403,
    x2: 14.6516,
    y2: 35.8071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7F8C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24CE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_220_3160",
    x1: 8.64785,
    y1: 32.731,
    x2: 8.69852,
    y2: 34.2836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_220_3160",
    x1: 11.7013,
    y1: 32.6316,
    x2: 11.752,
    y2: 34.1841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334C0F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3197,
    stopColor: "#344C12",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#374A1C",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7856,
    stopColor: "#3C482C",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    stopColor: "#444443",
    stopOpacity: 0.991
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.953,
    height: 33.0069,
    fill: "white",
    transform: "translate(4.57617 11.3457)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_220_3160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7317,
    height: 32.1003,
    fill: "white",
    transform: "translate(5.47363 11.9482)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon3);
export default __webpack_public_path__ + "static/media/list-icon3.d400c83f408ba8a2656a19cd515dcfec.svg";
export { ForwardRef as ReactComponent };